import { useLanguage } from '@/context/LanguageContext';
import SectionHeading from '@/components/SectionHeading';
import { Stagger, StaggerItem } from '@/components/Reveal';


export default function VehicleFleet() {
  const { t } = useLanguage();
  const items = t('vehicles.items');
  return (
    <section className="border-y border-brand-line bg-brand-alt/50 py-24" data-testid="vehicles-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading eyebrow="vehicles.eyebrow" title="vehicles.title" sub="vehicles.sub" align="center" />
        <Stagger className="mt-14 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6" gap={0.08}>
          {items.map((v, i) => (
            <StaggerItem key={v.name}>
              <div className="card-hover group overflow-hidden rounded-2xl border border-brand-line bg-white" data-testid={`vehicle-card-${i}`}>
                <div className="relative h-32 overflow-hidden">
                  <img src={v.img} alt={v.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <span className="absolute bottom-2 end-2 rounded-full bg-white/90 px-2.5 py-1 font-mono text-[9px] font-bold uppercase tracking-widest text-brand-blue glass">GPS</span>
                </div>
                <div className="p-4">
                  <h3 className="font-display text-sm font-extrabold text-brand-ink">{v.name}</h3>
                  <p className="mt-1 font-mono text-[9px] uppercase tracking-widest text-brand-dim">{v.tag}</p>
                </div>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
